import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/account",
				name: "account",
				component: () => import("../views/finance/account.vue"),
			},
			{
				path: "/bill",
				name: "bill",
				component: () => import("../views/finance/bill.vue"),
			},
			{
				path: "/item",
				name: "item",
				component: () => import("../views/finance/item.vue"),
			},
			{
				path: "/salary",
				name: "salary",
				component: () => import("../views/finance/salary.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/finance/config_right.vue"),
			},
			{
				path: "/config_shortcut",
				name: "config_shortcut",
				component: () => import("../views/finance/config_shortcut.vue"),
			},
			{
				path: "/dict_type",
				name: "dict_type",
				component: () => import("../views/finance/dict_type.vue"),
			},
			{
				path: "/dict_kjitem",
				name: "dict_kjitem",
				component: () => import("../views/finance/dict_kjitem.vue"),
			},
			{
				path: "/dict_item",
				name: "dict_item",
				component: () => import("../views/finance/dict_item.vue"),
			},
			{
				path: "/dict_flag",
				name: "dict_flag",
				component: () => import("../views/finance/dict_flag.vue"),
			},
			{
				path: "/report",
				name: "report",
				component: () => import("../views/finance/report.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
